import { fetchApi } from 'api/fetchApi'
import { definitions } from 'api/generated/search'
import {
  Children,
  Circumstance,
  Constitution,
  DatingGoals,
  Education,
  Gender,
  Home,
  Period,
  Sign,
  Smoke,
} from 'common-constants/api6.types'
import { DefaultSearchForm } from 'components/page/MainSearchSettings/constants'

export const fetchSearchSettingsListApi = () =>
  fetchApi<definitions['SearchFormResultWithRequest']>('/search/form/options')

export interface FieldVariant<V> {
  name: string
  value: V
}

interface FieldDescription {
  name: string
  formName: string
  isEnabled: boolean
}

interface FieldDescriptionWithRange extends FieldDescription {
  min: number
  max: number
  step: number
}

export interface FieldDescriptionWithVariants<V> extends FieldDescription {
  name: string
  formName: keyof DefaultSearchForm
  isEnabled: boolean
  variants: FieldVariant<V>[]
}

export interface SearchFields {
  whoIsLooking: FieldDescriptionWithVariants<Gender>
  lookFor: FieldDescriptionWithVariants<Gender>
  withPhoto: FieldDescriptionWithVariants<boolean>
  ageFrom: FieldDescription
  ageTo: FieldDescription
  target: FieldDescriptionWithVariants<DatingGoals>
  whoAreNear: FieldDescription
  periodType: FieldDescriptionWithVariants<unknown>
  period: FieldDescriptionWithVariants<Period>
  replyRate: FieldDescription
  heightFromSm: FieldDescriptionWithRange
  heightToSm: FieldDescriptionWithRange
  heightFromInch: FieldDescriptionWithRange
  heightToInch: FieldDescriptionWithRange
  heightUnit: FieldDescriptionWithVariants<unknown>
  weightFromKg: FieldDescriptionWithRange
  weightToKg: FieldDescriptionWithRange
  weightFromLb: FieldDescriptionWithRange
  weightToLb: FieldDescriptionWithRange
  weightUnit: FieldDescriptionWithVariants<unknown>
  lang: FieldDescriptionWithVariants<unknown>
  signExtended: FieldDescriptionWithVariants<Sign>
  education: FieldDescriptionWithVariants<Education>
  constitution: FieldDescriptionWithVariants<Constitution>
  race: FieldDescriptionWithVariants<string>
  smoke: FieldDescriptionWithVariants<Smoke>
  drink: FieldDescriptionWithVariants<unknown>
  orientation: FieldDescriptionWithVariants<unknown>
  circumstance: FieldDescriptionWithVariants<Circumstance>
  home: FieldDescriptionWithVariants<Home>
  location: FieldDescriptionWithVariants<unknown>
  children: FieldDescriptionWithVariants<Children>
}
